export const CLASS_TASK_ENTITY = "Class" as const;

export const CLASS_TASK_ACTIONS = {
  sendEmail: "Class.SendEmail",
  addFee: "Class.AddFee",
  addCredit: "Class.AddCredit",
  bulkDeactivate: "Class.BulkDeactivate",
} as const;

export const STUDENT_TASK_ENTITY = "Student" as const;

export const STUDENT_TASK_ACTIONS = {
  sendEmail: "Student.SendEmail",
  addFee: "Student.AddFee",
  bulkDeactivate: "Student.BulkDeactivate",
  bulkSetRecital: "Student.BulkSetRecital",
} as const;

export const USER_TASK_ENTITY = "User" as const;

export const USER_TASK_ACTIONS = {
  sendEmail: "User.SendEmail",
  bulkDeactivate: "User.BulkDeactivate",
  sendNotification: "User.SendNotification",
} as const;

export const APPOINTMENT_TASK_ENTITY = "Appointment" as const;

export const APPOINTMENT_TASK_ACTIONS = {
  sendEmail: "Appointment.SendEmail",
  bulkDeactivate: "Appointment.BulkDeactivate",
} as const;

export const TEACHER_TASK_ENTITY = "Teacher" as const;

export const TEACHER_TASK_ACTIONS = {
  sendEmail: "Teacher.SendEmail",
  bulkDeactivate: "Teacher.BulkDeactivate",
  sendNotification: "Teacher.SendNotification",
} as const;
